// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/FloatingCart/style.css
// module id = 1798
// module chunks = 0